import type { LeadListFilters } from '../types';

/**
 * Query key factory for the Leads feature.
 *
 * Always derive keys from this factory rather than hand-writing arrays so
 * mutation invalidation stays consistent across the feature.
 */
export const leadKeys = {
  all: ['leads'] as const,
  lists: () => [...leadKeys.all, 'list'] as const,
  list: (filters: LeadListFilters) => [...leadKeys.lists(), filters] as const,
  details: () => [...leadKeys.all, 'detail'] as const,
  detail: (id: string) => [...leadKeys.details(), id] as const,
};
